const MAX_LIVES = 10;
const BAR_WIDTH = 24;
const BAR_HEIGHT = 10;
const BAR_GAP = 3;
const START_X = 8;
const BAR_Y = 5;

interface LifeCounterProps {
  lives: number;
}

export function LifeCounter({ lives }: LifeCounterProps) {
  const clampedLives = Math.max(0, Math.min(MAX_LIVES, lives));

  return (
    <svg
      width="275"
      height="20"
      viewBox="0 0 275 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="lifeBarGradient" x1="0" y1="0" x2="0" y2="1">
          <stop stopColor="var(--color-life-counter-bar-fill-from)" />
          <stop offset="1" stopColor="var(--color-life-counter-bar-fill-to)" />
        </linearGradient>
        <clipPath id="lifeBarClip">
          <rect x={START_X} y={BAR_Y} width="267" height={BAR_HEIGHT} rx="5" fill="white" />
        </clipPath>
      </defs>

      {/* Life bars */}
      <g clipPath="url(#lifeBarClip)">
        {Array.from({ length: MAX_LIVES }).map((_, index) => {
          const x = START_X + index * (BAR_WIDTH + BAR_GAP);
          const isActive = index < clampedLives;

          return (
            <rect
              key={index}
              x={x}
              y={BAR_Y}
              width={BAR_WIDTH}
              height={BAR_HEIGHT}
              fill={isActive ? 'url(#lifeBarGradient)' : 'var(--color-g-80)'}
            />
          );
        })}
      </g>

      {/* Border */}
      <rect x="8.5" y="5.5" width="266" height="9" rx="4.5" stroke="white" />

      {/* Heart icon */}
      <path
        d="M10.3633 3.84961C12.4862 1.6045 14.7603 1.37081 16.4766 2.16797C18.2269 2.981 19.5 4.90964 19.5 7.19824C19.4999 9.51556 18.5631 11.297 17.2461 12.8047C15.9118 14.3321 14.2271 15.5398 12.7275 16.7432C12.2031 17.1637 11.7198 17.5451 11.25 17.8242C10.7798 18.1036 10.371 18.25 10 18.25C9.62899 18.25 9.22025 18.1036 8.75 17.8242C8.28021 17.5451 7.79691 17.1637 7.27246 16.7432C5.77287 15.5398 4.08819 14.3321 2.75391 12.8047C1.43691 11.297 0.50011 9.51556 0.5 7.19824C0.5 4.90964 1.77311 2.981 3.52344 2.16797C5.23971 1.37081 7.51376 1.6045 9.63672 3.84961L10 4.23438L10.3633 3.84961Z"
        fill="var(--color-life-counter-heart-fill)"
        stroke="white"
      />
    </svg>
  );
}
